import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { TaskViewModel } from '@trinnvis/dabih-api-client';
import { functionDeleted } from './function-deleted';
import { toList } from '../toList';

export const tasksNotDeleted = createSelector(getOrganization, (organization): TaskViewModel[] => {
  if (organization === undefined) return [];
  return toList(organization.tasksById).filter((e) => !e.deleted && !functionDeleted(organization, e.functionUuid));
});
